import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/service"
import { BaseResponse } from "../../api/types/common"

type initialState = {
    response: BaseResponse | null
    tckn: string | null
}

const tokenSlice = createSlice({
    name: "token",
    initialState: { response: null, tckn: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.getTokenByTckn1.matchFulfilled,
            (state, action) => {
                state.response = action.payload
                state.tckn = action.meta.arg.originalArgs
            }
        )
    }
})

export default tokenSlice.reducer




